import WebFont from 'webfontloader'

const options = {"google":{"families":["Roboto:400,500,700,900&display=swap","Roboto+Mono:400,500,700&display=swap"]}}

WebFont.load(options)
